/**
 * usePool Hook - Phase 2C-2
 * 
 * Fetches a single pool by ID.
 * Uses existing PoolService pattern.
 */

import { useState, useEffect, useCallback } from 'react';
import { Pool } from '../types';
import { PoolService, ApiError } from '../api';

interface UsePoolResult {
  pool: Pool | null;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export function usePool(poolId: string): UsePoolResult {
  const [pool, setPool] = useState<Pool | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPool = useCallback(async () => {
    if (!poolId) {
      setLoading(false);
      return;
    }
    
    setLoading(true);
    setError(null);
    try {
      const data = await PoolService.getById(poolId);
      setPool(data);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Failed to load pool');
    } finally {
      setLoading(false);
    }
  }, [poolId]);

  useEffect(() => {
    fetchPool();
  }, [fetchPool]);

  return { pool, loading, error, refetch: fetchPool };
}
